import JobInformation from "./JobInformation";
import { useEffect, useState } from "react";
import {
  InvoiceStatusLabel,
  userPermissions,
} from "../../../../Utils/constants";
import SimpleBackdrop from "../../../../Components/SimpleBackDrop";
import PdfRendering from "../../../../Components/PdfRendering";
import { useInvoiceProvider } from "../../../../Providers/Client/invoice";
import StatusLabel from "../../../../Components/StatusLabel";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

export default function ViewInvoice({ showJobInfo = true }) {
  const {
    invoiceLink,
    getInvoicePdfLink,
    markInvoiceAsPaid,
    invoices,
    fetchInvoiceForUser,
  } = useInvoiceProvider();
  const [loading, setLoading] = useState(false);
  const permissions = useSelector((state) => state.user.permissions);
  const [invoice, setInvoice] = useState();
  const [invoiceid, setInvoiceId] = useState();

  const { id } = useParams();

  useEffect(() => {
    fetchInvoiceForUser();
  }, [invoice]);

  let row;

  useEffect(() => {
    if (id) {
      setInvoiceId(id);
    }
    if ((id || invoiceid) && invoices.length > 0) {
      // Find the row that matches the 'id' prop
      const row = invoices.find((invoice) => invoice?.id === (invoiceid || id));
      if (row) {
        setInvoice({
          jobId: row.job_id,
          start: row.month,
          invoiceId: row.id,
          invoiceStatus: row.status,
          vendor: row.vendor,
        });
      }
    }
  }, [invoiceid, id]);

  useEffect(() => {
    getInvoicePdfLink(id || invoice?.invoiceId);
  }, [invoice, id]);

  const updateInvoiceStatus = () => {
    markInvoiceAsPaid(id || invoice?.invoiceId);
    invoice.invoiceStatus = "PAID";
    setInvoice(invoice);
    Swal.fire("", "Invoice Paid Successfully", "success");
  };

  return (
    <div>
      <SimpleBackdrop open={loading} />
      <JobInformation />
      {/* {showJobInfo ? (
        { invoice && <JobInformation
          jobId={invoice?.jobId}
          setJobInfo={setInvoice}
          withInvoice={false}
          vendorDetails={invoice?.vendor}
        />}
      ) : (
      <div className="pt-4">
        <span
          className="cursor-pointer mb-4"
          onClick={() => {
            setInvoice(false);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
            />
          </svg>
        </span>
      </div>
      )} */}

      <div className="flex flex-col bg-white rounded-lg font-[Roboto] p-4 space-y-3 mt-8">
        {invoice?.invoiceStatus && (
          <div className="flex flex-row space-x-6 justify-end items-center">
            <StatusLabel data={InvoiceStatusLabel[invoice?.invoiceStatus]} />
          </div>
        )}

        {invoiceLink && (
          <div className="mx-auto py-4">
            <PdfRendering link={invoiceLink} />
          </div>
        )}
        {invoiceLink && (
          <div className="ml-auto">
            <a
              href={invoiceLink}
              style={{
                border: "1px solid #2EBAA3",
                borderRadius: "4px",
                color: "#2EBAA3",
                padding: "0.6rem 2rem",
              }}
              download
              target="_blank"
              rel="noreferrer"
            >
              download invoice
            </a>
          </div>
        )}
        {permissions?.includes(`admin-client`) ||
        permissions?.includes(userPermissions.job.invoiceAction)
          ? invoice?.invoiceStatus !== "PAID" && (
              <div className="ml-auto pt-4 space-x-4">
                <button
                  onClick={() => {
                    updateInvoiceStatus();
                  }}
                  style={{
                    width: "144px",
                    height: "34px",
                    background: "#2EBAA3",
                    borderRadius: "4px",
                    color: "white",
                  }}
                >
                  Mark it paid
                </button>
                <button
                  style={{
                    width: "144px",
                    height: "34px",
                    background: "#2EBAA3",
                    borderRadius: "4px",
                    color: "white",
                  }}
                >
                  Pay
                </button>
              </div>
            )
          : null}
      </div>
    </div>
  );
}
